export const zh = {
  nav: {
    home: '首页',
    about: '关于学院',
    programs: '课程',
    services: '服务',
    courses: '培训课程',
    team: '团队成员',
    news: '新闻',
    contact: '联系我们',
    blog: '博客',
  },
  hero: {
    badge: '国际认证教育机构',
    title: 'SAI也门中国教育学院',
    subtitle: '也门汉语教育的领导者',
    description: '我们提供创新的教育项目，结合语言精通和中国文化理解，为也门学生打开全球视野',
    cta1: '探索课程',
    cta2: '联系我们',
  },
  trust: {
    students: '名学生',
    success: '成功率',
    scholarships: '个奖学金',
  },
  features: {
    title: '为什么选择SAI学院？',
    feature1Title: '互动教学',
    feature1Desc: '现代课程专注于发音和会话',
    feature2Title: '国际证书',
    feature2Desc: 'HSK和YCT考试培训中心',
    feature3Title: '文化交流',
    feature3Desc: '帮助学生了解中国生活和机会的项目',
  },
  programs: {
    title: '我们的学术课程',
    subtitle: '选择适合您教育和职业目标的课程',
    viewAll: '查看全部',
    program1Title: '成人汉语课程',
    program1Desc: '从基础到完全精通的强化文凭课程，专为也门的专业人士和大学生设计',
    program2Title: '儿童和青少年汉语课程（YCT）',
    program2Desc: '使用多媒体的有趣互动教学，帮助年轻一代轻松掌握第二语言',
    program3Title: '商务汉语',
    program3Desc: '专为与中国市场打交道的也门商人和公司定制的课程，包括贸易术语和商务礼仪',
    duration: '课程时长',
    level: '级别',
    certificate: '证书',
  },
  about: {
    title: '关于SAI学院',
    subtitle: '我们在也门和中国之间架起沟通桥梁的旅程',
    whoWeAre: '我们是谁？',
    whoWeAreDesc: 'SAI学院是萨那领先的教育机构，旨在建立也门与中国之间的文化和学术交流桥梁。我们相信学习语言是理解未来经济力量的关键。',
    vision: '我们的愿景',
    visionDesc: '成为也门和地区汉语教育的首选参考和最重要平台。',
    values: '我们的价值观',
    value1: '学术质量',
    value2: '教学创新',
    value3: '文化诚信',
  },
  news: {
    title: '新闻与活动',
    subtitle: 'SAI学院的最新新闻和学术活动',
    readMore: '阅读更多',
    cat1: '学术项目',
    cat2: '奖学金',
    cat3: '文化活动',
    news1Title: 'HSK强化课程开班',
    news1Desc: '在中国专业教师的指导下，HSK 4级和5级强化备考课程正式启动',
    news1Date: '2025年1月15日',
    news2Title: '优秀学生新奖学金',
    news2Desc: '宣布为下一学年提供15个全额奖学金，用于在中国著名大学学习',
    news2Date: '2025年1月10日',
    news3Title: '中国文化工作坊',
    news3Desc: '与孔子学院专家一起举办中国书法和茶道传统互动工作坊',
    news3Date: '2025年1月5日',
  },
  testimonials: {
    badge: '学生评价',
    title: '学生评价与反馈',
    subtitle: '我们的学生对SAI学院学习体验的评价',
    student1Name: '艾哈迈德·穆罕默德·沙米',
    student1Role: '汉语课程毕业生',
    student1Text: 'SAI学院彻底改变了我的生活。通过强化课程，我获得了北京大学的奖学金，现在成为了一名认证翻译。老师们专业，课程非常实用。',
    student2Name: '法蒂玛·阿里·哈达德',
    student2Role: '商务课程学生',
    student2Text: '我在一家进出口公司工作，商务汉语课程帮助我与中国合作伙伴沟通。现在我可以自信地进行谈判。',
    student3Name: '哈立德·赛义德·马克塔里',
    student3Role: '二年级学生',
    student3Text: 'SAI学院的学习环境很棒。教室配备了最新技术，文化活动使学习变得有趣。我建议每个想学汉语的人加入。',
  },
  contact: {
    title: '联系我们',
    subtitle: '我们在这里回答您的问题并帮助您开始教育之旅',
    address: '地址',
    addressText: '里马斯环岛，胡达街，萨那 - 也门共和国',
    phone: '电话',
    phone1: '00967775182228',
    phone2: '009671260640',
    email: '电子邮件',
    emailText: 'info@sai-college.com',
    hours: '工作时间',
    hoursText: '周六至周四，上午8:00至晚上8:00',
    formTitle: '给我们留言',
    name: '姓名',
    emailLabel: '电子邮件',
    subject: '主题',
    message: '留言',
    send: '发送',
    sending: '发送中...',
    success: '您的消息已成功发送！',
    error: '发生错误。请重试。',
  },
  visitBooking: {
    badge: '立即预订',
    title: '访问学院',
    subtitle: '预订访问SAI学院，探索我们的现代化设施，与我们的教授见面，并获得全面的介绍性参观',
    formTitle: '预订学院访问',
    formSubtitle: '填写表格，我们将与您联系确认预约',
    fullName: '全名',
    phone: '电话号码',
    email: '电子邮件',
    visitDate: '访问日期',
    visitTime: '首选时间',
    purpose: '访问目的',
    numberOfVisitors: '访客人数',
    notes: '附加说明',
    selectTime: '选择时间',
    morning: '上午 (8:00 - 12:00)',
    afternoon: '下午 (12:00 - 16:00)',
    evening: '晚上 (16:00 - 20:00)',
    selectPurpose: '选择目的',
    tour: '参观游览',
    admission: '招生咨询',
    interview: '学术面试',
    facilities: '参观设施',
    other: '其他',
    availableDays: '周六至周四可用',
    fridayClosed: '抱歉，学院周五关闭',
    submit: '确认预订',
    submitting: '发送中...',
    successTitle: '预订确认成功！',
    successMessage: '感谢您预订访问SAI学院。我们将很快与您联系确认详细信息。',
    bookingReference: '预订参考号',
    bookAnother: '预订另一个访问',
    infoNote: '我们将在24小时内与您联系确认访问预约。如果所需时间不可用，我们将为您提供合适的替代方案。',
    charactersLimit: '字符',
  },
  aboutPage: {
    title: '关于学院',
    whoWeAre: '我们是谁？',
    whoWeAreDesc: 'SAI学院是萨那领先的教育机构，旨在建立也门与中国之间的文化和学术交流桥梁。我们相信学习语言是理解未来经济力量的关键。',
    vision: '我们的愿景',
    visionDesc: '成为也门和地区汉语教育的首选参考和最重要平台。',
    mission: '我们的使命',
    missionDesc: '提供高质量的汉语和文化教育，使也门学生能够利用中国和世界的学术和职业机会。',
    values: '我们的价值观',
    value1: '学术质量',
    value1Desc: '我们致力于最高的国际教育标准',
    value2: '教学创新',
    value2Desc: '我们使用最新的互动教学方法',
    value3: '文化诚信',
    value3Desc: '我们尊重并促进真实的文化交流',
  },
  servicesPage: {
    title: '我们的服务',
    subtitle: '我们提供全面的教育和咨询服务',
    service1Title: '教育咨询',
    service1Desc: '我们帮助也门学生选择合适的专业和中国著名大学。',
    service2Title: '翻译和本地化',
    service2Desc: '为在也门运营的公司和机构提供专业翻译服务（中文-阿拉伯语-英语）。',
    service3Title: '文化培训',
    service3Desc: '关于中国文化、书法艺术和茶道传统的工作坊，以加深文化理解。',
  },
  scholarships: {
    badge: '可用奖学金',
    title: '奖学金项目',
    subtitle: '通过SAI学院的学术卓越奖学金投资您的未来',
    s1Title: '学术优秀奖学金',
    s1Desc: '为学术优秀的学生提供全额奖学金，在中国顶尖大学学习，全面覆盖学费和住宿费。',
    s1Value: '全额奖学金100%',
    s1Deadline: '截止日期：2025年3月',
    s1Cond1: '累计平均成绩不低于90%',
    s1Cond2: '通过HSK 4级考试',
    s1Cond3: '两封教授推荐信',
    s2Title: 'HSK语言卓越奖学金',
    s2Desc: '为在HSK考试中取得高分的学生提供部分奖学金，鼓励汉语精通方面的卓越表现。',
    s2Value: '覆盖75%',
    s2Deadline: '截止日期：2025年6月',
    s2Cond1: '通过HSK 5级，成绩250+',
    s2Cond2: 'SAI学院在读学生',
    s2Cond3: '学习目标论文',
    s3Title: '商务贸易奖学金',
    s3Desc: '专为希望学习商务汉语并扩大商业伙伴关系的商人和专业人士提供的奖学金。',
    s3Value: '覆盖50%',
    s3Deadline: '截止日期：2025年9月',
    s3Cond1: '至少两年工作经验',
    s3Cond2: '明确的对华商业计划',
    s3Cond3: '基础汉语水平',
    s4Title: '国际文化交流奖学金',
    s4Desc: '为优秀学生提供参加中国大学一个完整学期文化交流项目的奖学金。',
    s4Value: '全额覆盖+旅费',
    s4Deadline: '截止日期：2026年1月',
    s4Cond1: '在SAI学院完成一学年学习',
    s4Cond2: '积极参与文化活动',
    s4Cond3: '通过面试',
    note: '如需申请任何奖学金，请访问招生办公室或通过电子邮件与我们联系。',
  },
  gallery: {
    badge: '照片画廊',
    title: '难忘时刻',
    subtitle: '探索SAI学院最精彩的活动和学生活动',
    img1Title: '互动课堂',
    img1Date: '2025年1月',
    img2Title: '中国书法工作坊',
    img2Date: '2024年12月',
    img3Title: '年度毕业典礼',
    img3Date: '2024年11月',
    img4Title: '文化交流节',
    img4Date: '2024年10月',
    img5Title: '学生学术会议',
    img5Date: '2024年9月',
    img6Title: '中国博物馆参观',
    img6Date: '2024年8月',
  },
  faq: {
    badge: '综合指南',
    title: '常见问题',
    subtitle: '关于在SAI教育学院学习您需要了解的一切',
    cat1: '录取与注册',
    q1: 'SAI学院的录取条件是什么？',
    a1: '申请SAI学院需要至少持有高中毕业证书。不要求具备汉语基础知识，因为我们的课程从基础级别开始。可以通过招生办公室或在线提交入学申请。',
    q2: '下学期的注册期什么时候开始？',
    a2: '第一学期的注册于每年8月开放，第二学期于1月开放。我们建议尽早注册以确保获得名额，因为某些课程的名额有限。',
    q3: '我可以同时注册多个课程吗？',
    a3: '是的，您可以注册一个主要课程和一个附加课程，如商务汉语或文化工作坊，前提是时间不冲突。学术指导团队将帮助您选择合适的时间表。',
    q4: '你们接受萨那以外的学生吗？',
    a4: '当然！我们欢迎来自也门所有省份的学生。我们为来自萨那以外的学生提供指导服务，帮助他们在学院附近找到合适的住所。',
    cat2: '费用与奖学金',
    q5: '在SAI学院学习的费用是多少？',
    a5: '费用因所选课程而异。强化文凭课程的费用与同类机构相比具有竞争力。我们还提供灵活的月付分期付款计划，方便学生缴费。',
    q6: '如何申请奖学金？',
    a6: '您可以通过填写招生办公室或我们网站上的申请表来申请奖学金。需要附上所需文件，如学术证书、HSK考试成绩和推荐信。',
    q7: '提前注册或团体注册有折扣吗？',
    a7: '是的，学期开始前一个月提前注册可享受10%折扣，3人及以上团体注册可享受15%折扣。我们还为合作公司员工子女提供特别折扣。',
    cat3: '学术生活',
    q8: '强化文凭课程的时长是多少？',
    a8: '强化文凭课程为期两个学年（4个学期）。课程包括从初级到高级的汉语学习，以及文化、翻译和HSK考试准备课程。',
    q9: '教学语言是阿拉伯语还是中文？',
    a9: '在初级阶段，教学使用阿拉伯语和中文的混合方式以确保充分理解。随着学生的进步，中文使用比例逐渐增加，直到在高级阶段成为主要教学语言。',
    q10: '学院颁发认证证书吗？',
    a10: '是的，SAI学院颁发国内和国际认可的证书。我们也是HSK和YCT考试的认证中心，使学生能够获得全球认可的汉语水平证书。',
    ctaTitle: '没有找到您问题的答案？',
    ctaDesc: '我们的团队随时准备回答您的所有问题，帮助您的教育之旅',
    ctaButton: '联系我们',
  },
  team: {
    hero: {
      title: '杰出团队',
      subtitle: '在学术教育和国际合作方面经验丰富的精英教授和员工'
    },
    contact: {
      email: '电子邮件',
      linkedin: '领英'
    },
    noResults: '没有结果',
    cta: {
      title: '加入我们的学术大家庭',
      description: '我们一直在寻找优秀人才加入我们的团队。联系我们了解可用机会',
      contactButton: '联系我们',
      registerButton: '立即注册'
    }
  },
};

export default zh;